import React from 'react';
import { Box, xcss } from '@atlaskit/primitives';
var Line = xcss({
  height: '1px',
  width: '100%',
  background: "var(--ds-border, #091E4224)"
});
export var SeparatorLine = function SeparatorLine() {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: Line
  });
};